import React, { useEffect, useState } from "react";
import { Grid, useTheme } from "@material-ui/core";
import StateCard from "./Card";
import { useSelector, useDispatch } from "react-redux";
import externalsMaterialsActions from "../../../../redux/actions/externalsMaterials";

export default function Cards() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const externalsMaterials = useSelector((state) => state.externalsMaterials);

  const [pending, setPending] = useState("...");
  const [approved, setApproved] = useState("...");
  const [notifyToggle, setNotifyToggle] = useState(false);
  const [cont, setCont] = useState(0);

  useEffect(() => {
    if (externalsMaterials.cards) {
      setPending(externalsMaterials.cards.pending);
      setApproved(externalsMaterials.cards.approved);
      setCont(0);
    }
  }, [externalsMaterials.cards]);

  useEffect(() => {
    let interval = null;
    if (cont < 8) {
      interval = setInterval(() => {
        setNotifyToggle(!notifyToggle);
        setCont(cont + 1);
      }, 300);
      return () => clearInterval(interval);
    } else {
      setNotifyToggle(true);
    }
  }, [notifyToggle, cont]);

  const setSelector = (value) => {
    dispatch(externalsMaterialsActions.setSelector(value));
  };

  return (
    <Grid container spacing={2}>
      <Grid item sm={3} xs={6} onClick={() => setSelector("APPROVED")}>
        <StateCard
          title="APROBADOS"
          value={approved ? approved : "..."}
          background={
            externalsMaterials.selector === "APPROVED"
              ? theme.palette.successGradient.main
              : theme.palette.primaryGradient.main
          }
        />
      </Grid>
      <Grid item sm={3} xs={6} onClick={() => setSelector("PENDING")}>
        <StateCard
          title="PENDIENTES"
          value={pending ? pending : "..."}
          background={
            externalsMaterials.selector === "PENDING"
              ? theme.palette.successGradient.main
              : pending && notifyToggle
              ? theme.palette.warningGradient.main
              : theme.palette.primaryGradient.main
          }
        />
      </Grid>
      <Grid item xs={12}>
        <hr />
      </Grid>
    </Grid>
  );
}
